export default __webpack_public_path__ + "static/media/creandum-logo.eafc8120.png";